function syncBosqueHeaderHeight() {
  const header = document.querySelector('.bc-site-header');
  if (!header) return;
  document.documentElement.style.setProperty('--bc-header-stack-height', `${header.getBoundingClientRect().height}px`);
}

function initializeBosqueHero(hero) {
  if (hero.dataset.bcHeroInitialized === 'true') return;
  hero.dataset.bcHeroInitialized = 'true';

  const slides = Array.from(hero.querySelectorAll('[data-bc-slide]'));
  const controls = Array.from(hero.querySelectorAll('[data-bc-control]'));
  const previous = hero.querySelector('[data-bc-previous]');
  const next = hero.querySelector('[data-bc-next]');
  let activeIndex = 0;
  let timer;
  let pausedByUser = false;
  let focused = false;
  const interval = Number(hero.dataset.interval || 10000);
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const toggle = hero.querySelector('[data-bc-toggle]');
  const toggleText = hero.querySelector('[data-bc-toggle-text]');

  const restartProgress = () => {
    slides.forEach((slide) => {
      slide.removeAttribute('data-progress');
    });
    if (reducedMotion || slides.length < 2) return;
    const activeSlide = slides[activeIndex];
    if (!activeSlide) return;
    void activeSlide.offsetWidth;
    activeSlide.dataset.progress = 'running';
  };

  const show = (index) => {
    activeIndex = index;
    slides.forEach((slide, slideIndex) => {
      slide.setAttribute('aria-hidden', String(slideIndex !== index));
      slide.toggleAttribute('inert', slideIndex !== index);
      if (slideIndex === index) {
        slide.dataset.position = 'active';
      } else if (slideIndex < index) {
        slide.dataset.position = 'before';
      } else {
        slide.dataset.position = 'after';
      }
    });
    controls.forEach((control, controlIndex) => control.setAttribute('aria-current', String(controlIndex === index)));
    restartProgress();
  };
  const stop = () => window.clearInterval(timer);
  const start = () => {
    stop();
    if (slides.length < 2 || reducedMotion || pausedByUser || focused || document.hidden) return;
    restartProgress();
    timer = window.setInterval(() => show((activeIndex + 1) % slides.length), interval);
  };
  const updateToggle = () => {
    const paused = pausedByUser || focused || document.hidden;
    hero.dataset.paused = String(paused);
    if (!toggle) return;
    toggle.setAttribute('aria-pressed', String(pausedByUser));
    toggle.setAttribute('aria-label', pausedByUser ? 'Reanudar rotación' : 'Pausar rotación');
    if (toggleText) toggleText.textContent = pausedByUser ? '▶' : 'Ⅱ';
  };

  previous?.addEventListener('click', () => {
    show((activeIndex - 1 + slides.length) % slides.length);
    start();
  });
  next?.addEventListener('click', () => {
    show((activeIndex + 1) % slides.length);
    start();
  });
  controls.forEach((control, index) => control.addEventListener('click', () => { show(index); start(); }));
  toggle?.addEventListener('click', () => {
    pausedByUser = !pausedByUser;
    updateToggle();
    start();
  });
  hero.addEventListener('focusin', (event) => {
    const keyboardFocused = event.target.matches(':focus-visible');
    if (focused === keyboardFocused) return;
    focused = keyboardFocused;
    updateToggle();
    if (focused) stop();
    else start();
  });
  hero.addEventListener('focusout', (event) => {
    if (event.relatedTarget && hero.contains(event.relatedTarget)) return;
    if (!focused) return;
    focused = false;
    updateToggle();
    start();
  });
  document.addEventListener('visibilitychange', () => {
    updateToggle();
    start();
  });
  updateToggle();
  start();
}

function bootBosqueHeros(root = document) {
  syncBosqueHeaderHeight();
  root.querySelectorAll('[data-bc-hero]').forEach(initializeBosqueHero);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bootBosqueHeros, { once: true });
} else {
  bootBosqueHeros();
}

if (!window.bcHeroEditorEventsBound) {
  window.bcHeroEditorEventsBound = true;
  window.addEventListener('resize', syncBosqueHeaderHeight);
  document.addEventListener('shopify:section:load', (event) => {
    syncBosqueHeaderHeight();
    bootBosqueHeros(event.target);
  });
}
